import qsRequest from "@/api/qsRequest";

export async function getPartners() {
    const res = await qsRequest({
        method: "get",
        url: "/partner"
    })
    const {data} = res.data
    return {
        partners: data
    }
}